module.exports = __webpack_public_path__ + "img/punkte-gruppe.67dd6a4.svg";